export const SUPERUSERLEVELS = [
  {
    levelname: "Super User",
    columnName: "Super User",
    emailId: "",
    active: false,
  },
  {
    levelname: "Regional Sales Director",
    columnName: "RSD",
    emailId: "",
    active: true,
  },
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Assistant Area Sales Manager",
    columnName: "AASM",
    emailId: "",
    active: false,
  },
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const CDVPLEVELS = [
  {
    levelname: "CD VP",
    columnName: "CD VP",
    emailId: "",
    active: false,
  },
  {
    levelname: "Regional Sales Director",
    columnName: "RSD",
    emailId: "",
    active: true,
  },
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Assistant Area Sales Manager",
    columnName: "AASM",
    emailId: "",
    active: false,
  },
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const BMLEVELS = [
  {
    levelname: "Regional Sales Director",
    columnName: "RSD",
    emailId: "",
    active: false,
  },
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: true,
  },
  {
    levelname: "Assistant Area Sales Manager",
    columnName: "AASM",
    emailId: "",
    active: false,
  },
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const ASMLEVELS = [
  {
    levelname: "Area Sales Manager",
    columnName: "Area Sales Manager",
    emailId: "",
    active: false,
  },
  {
    levelname: "Assistant Area Sales Manager",
    columnName: "AASM",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const SUPLEVELS = [
  {
    levelname: "Assistant Area Sales Manager",
    columnName: "AASM",
    emailId: "",
    active: false,
  },
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: true,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const DTLEVELS = [
  {
    levelname: "DT Operator",
    columnName: "DT Operator",
    emailId: "",
    active: false,
  },
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: true,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const TLLEVELS = [
  {
    levelname: "OM DSS",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    columnName: "Sales Person",
    emailId: "",
    active: true,
  },
];

export const SUPERUSERDISTRIBUTORlEVELS = [
  {
    levelname: "Super User",
    role: "Super User",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    role: "LEVEL4",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const CDVPDISTRIBUTORlEVELS = [
  {
    levelname: "CD VP",
    role: "CD VP",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    role: "LEVEL4",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const BMDISTRIBUTORlEVELS = [
  {
    levelname: "Regional Sales Director",
    role: "Regional Sales Director",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    role: "LEVEL4",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const ASMDISTRIBUTORlEVELS = [
  {
    levelname: "Area Sales Manager",
    role: "Area Sales Manager",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    role: "LEVEL4",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const SUPDISTRIBUTORlEVELS = [
  {
    levelname: "Assistant Area Sales Manager",
    role: "Assistant Area Sales Manager",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    role: "LEVEL4",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const DTOPERATORLEVELS = [
  {
    levelname: "DT Operator",
    role: "DT Operator",
    columnName: "DT Site Code",
    emailId: "",
    active: false,
  },
  {
    levelname: "Distributor",
    role: "LEVEL2",
    columnName: "DT Site Code",
    emailId: "",
    active: true,
  },
  {
    levelname: "OM DSS",
    role: "LEVEL3",
    columnName: "Team Leads",
    emailId: "",
    active: false,
  },
  {
    levelname: "Salesman",
    role: "LEVEL4",
    columnName: "Sales Person",
    emailId: "",
    active: false,
  },
];

export const getLevelsID = (role) => {
  switch (role) {
    case "Super User": {
      return SUPERUSERLEVELS;
    }
    case "CD VP": {
      return CDVPLEVELS;
    }
    case "Regional Sales Director": {
      return BMLEVELS;
    }
    case "Area Sales Manager": {
      return ASMLEVELS;
    }
    case "Assistant Area Sales Manager": {
      return SUPLEVELS;
    }
    case "DT Operator": {
      return DTLEVELS;
    }
    case "OM DSS": {
      return TLLEVELS;
    }
    default: {
      return CDVPLEVELS;
    }
  }
};

export const getDistributorLevelsID = (role) => {
  switch (role) {
    case "Super User": {
      return SUPERUSERDISTRIBUTORlEVELS;
    }
    case "CD VP": {
      return CDVPDISTRIBUTORlEVELS;
    }
    case "Regional Sales Director": {
      return BMDISTRIBUTORlEVELS;
    }
    case "Area Sales Manager": {
      return ASMDISTRIBUTORlEVELS;
    }
    case "Assistant Area Sales Manager": {
      return SUPDISTRIBUTORlEVELS;
    }
    case "DT Operator": {
      return DTOPERATORLEVELS;
    }
    default: {
      return CDVPDISTRIBUTORlEVELS;
    }
  }
};
